<template>
  <div>
    <p>&emsp;</p>
    <el-table :data="data" height="180" class="common-el-table-styles" border style="width: 100%">
      <el-table-column width="width" :label="colLabel">
        <template slot-scope="{ row }">
          <el-radio class="profile-radio" :value="value" @change="$emit('input', row.promoted_object_id)" :label="row.promoted_object_id">
            {{ row.promoted_object_name }}</el-radio
          >
        </template>
      </el-table-column>

      <el-table-column label="头像" width="300">
        <template slot-scope="{ row }">
          <el-image
            shape="square"
            style="width: 26px; height: 26px"
            :preview-src-list="[row.icon]"
            fit="contain"
            :src="row.icon"
          ></el-image>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    colLabel: {
      type: String,
      default: '视频号'
    },
    data: Array,
    value: [String, Number]
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
